import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Blunt DC · Your Trusted Source</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          At Blunt DC, we provide comprehensive coverage of cannabis law and policy updates, along with educational content to enhance your understanding of cannabis culture in our area.
        </p>
        <div className="cta-row">
          <a href="/news" target="_blank">
            Read the Latest News
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated on the latest changes in cannabis legislation and how they impact our community.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information about the legal status of cannabis in our area, including usage, possession, and cultivation guidelines.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Explore a variety of articles and guides that delve into the science, history, and culture of cannabis.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;